/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IReviewedCount } from './reviewed-count-schema';
import { reviewedCountSchema } from './reviewed-count-schema';

export const getReviewedCountsResponseSchema = createApiResponseSchema(
  z.array(reviewedCountSchema),
) as z.ZodSchema<IAPI<IReviewedCount[]>>;

export type IGetReviewedCountsResponse = IAPI<IReviewedCount[]>;
